import { createSlice } from "@reduxjs/toolkit";
import { AIPMoveInState } from "@/types/moveIn.types";

const initialState: AIPMoveInState = {
  showWelcomeOverlayAIPTenant: false,
  isAIPMoveInUnit: false,
  journeyData: null,
  isLoading: false,
  selectedAIPUnit: null,
};

const aipMoveInSlice = createSlice({
  name: "aipMoveIn",
  initialState,
  reducers: {
    setAIPMoveInState: (state, action: { payload: Partial<AIPMoveInState> }) => {
      return { ...state, ...action.payload };
    },
    resetAIPMoveIn: () => initialState,
  },
});

export const { setAIPMoveInState, resetAIPMoveIn } = aipMoveInSlice.actions;

export default aipMoveInSlice.reducer;
